<div class="row">
    <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
        <div class="text_header mt-5">
            <p>Trámites pendientes a validar</p>
            <p>Licencia para prestación de servicios en Seguridad y Salud en el Trabajo</p>
        </div>
    </div>
</div>

<section *ngIf="showFormByUser==false">
    <form [formGroup]="validatorForm">
        <div class="row">
            <div class="col-xxl-4 col-md-4 col-lg-4 col-sm-12 col-xs-12">
                <div class="">
                    <select class="form-select form-control" aria-label="Default select example" formControlName="pageSize"
                            (change)="changeDataTable()">
                        <option *ngFor="let item of pageSizeOptions" selected [value]="item">Mostrar {{item}} registros</option>
                    </select>
                </div>
            </div>
            <div class="col-xxl-4 col-md-4 col-lg-4 col-sm-12 col-xs-12">
                <div class="">
                    <input type="text" class="form-control search" id="search" placeholder="Palabras claves" formControlName="textToSearch" />
                </div>
            </div>
            <div class="col-xxl-4 col-md-4 col-lg-4 col-sm-12 col-xs-12">
                <div class="">
                    <button class="btn btn-success btn_search btn_block" (click)="changeDataTable()">
                        Consultar <i class="fa-solid fa-magnifying-glass" style="margin-left: 5px;"></i>
                    </button>
                </div>
            </div>


        </div>
    </form>

    <div class="row mt-4">
        <div class="col-xxl-12 col-md-12 col-lg-12 info_table">
            <div class="table-responsive">
                <table class="table" aria-describedby="Bandeja del funcionario">
                    <thead>
                        <tr>
                            <th>
                                <div class="filter-container header-container">
                                    <div class="header-text">ID trámite</div>
                                    <div class="icon-right">
                                        <span class="fa fa-sort-asc fa-lg sort-icon" (click)="sortAscDesNumber('id', 'up')"></span>
                                        <span class="fa fa-sort-desc fa-lg sort-icon" (click)="sortAscDesNumber('id', 'down')"></span>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="filter-container header-container">
                                    <div class="header-text">Identificación</div>
                                    <div class="icon-right">
                                        <span class="fa fa-sort-asc fa-lg sort-icon" (click)="sortAscDesNumber('identificationNumber', 'up')"></span>
                                        <span class="fa fa-sort-desc fa-lg sort-icon"
                                              (click)="sortAscDesNumber('identificationNumber', 'down')"></span>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="filter-container header-container">
                                    <div class="header-text">Nombre</div>
                                    <div class="icon-right">
                                        <span class="fa fa-sort-asc fa-lg sort-icon" (click)="sortAscDes('fullName', 'up')"></span>
                                        <span class="fa fa-sort-desc fa-lg sort-icon" (click)="sortAscDes('fullName', 'down')"></span>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="filter-container header-container">
                                    <div class="header-text">Tipo Trámite</div>
                                    <div class="icon-right">
                                        <span class="fa fa-sort-asc fa-lg sort-icon" (click)="sortAscDes('process', 'up')"></span>
                                        <span class="fa fa-sort-desc fa-lg sort-icon" (click)="sortAscDes('process', 'down')"></span>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="filter-container header-container">
                                    <div class="header-text">Fecha radicación</div>
                                    <div class="icon-right">
                                        <span class="fa fa-sort-asc fa-lg sort-icon" (click)="sortAscDesNumber('registrationDate', 'up')"></span>
                                        <span class="fa fa-sort-desc fa-lg sort-icon" (click)="sortAscDesNumber('registrationDate', 'down')"></span>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="filter-container header-container">
                                    <div class="header-text">Estado trámite</div>
                                    <div class="icon-right">
                                        <span class="fa fa-sort-asc fa-lg sort-icon" (click)="sortAscDes('status', 'up')"></span>
                                        <span class="fa fa-sort-desc fa-lg sort-icon" (click)="sortAscDes('status', 'down')"></span>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="filter-container header-container">
                                    <div class="header-text">Fecha Estado</div>
                                    <div class="icon-right">
                                        <span class="fa fa-sort-asc fa-lg sort-icon" (click)="sortAscDesNumber('dateTracking', 'up')"></span>
                                        <span class="fa fa-sort-desc fa-lg sort-icon" (click)="sortAscDesNumber('dateTracking', 'down')"></span>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="filter-container header-container">
                                    <div class="header-text">Tiempo de respuesta</div>
                                    <div class="icon-right">
                                        <span class="fa fa-sort-asc fa-lg sort-icon" (click)="sortAscDesNumber('responseTime', 'up')"></span>
                                        <span class="fa fa-sort-desc fa-lg sort-icon" (click)="sortAscDesNumber('responseTime', 'down')"></span>
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="filter-container header-container">
                                    <div class="header-text">Acciones</div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of tableFilter; let i= index">
                            <td>{{item.filedNumber}}</td>
                            <td *ngIf="item.personTypeId == 1"><span style="margin: 10px; font-weight: bold;">{{item.identificationCode}}</span>
                                {{item.identificationNumber}}
                            </td>
                            <td *ngIf="item.personTypeId == 2"><span style="margin: 10px; font-weight: bold;">NIT</span>{{item.identificationNumber}}
                            </td>
                            <td *ngIf="item.personTypeId == 1">{{item.fullName}}</td>
                            <td *ngIf="item.personTypeId == 2">{{item.legalRepresentativeName}}</td>
                            <td>{{item.process}}</td>
                            <td>{{item.registrationDate | date: 'dd/MM/yyyy hh:mm a'}}</td>
                            <td>{{item.status}}</td>
                            <td>{{item.dateTracking | date: 'dd/MM/yyyy hh:mm a'}}</td>
                            <td id="color_{{i}}">{{changeColor(item.responseTime, i)}}</td>
                            <td class="text-justify"><a (click)="getTramiteActual(item.id)"><span class="govco-edit-1">Ver</span> </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-xxl-12">
            <div class="colum_paginator">
                <mat-paginator class="paginator" [hidePageSize]="true" [length]="totalRequests" [pageSize]="pageSizePaginator"
                               (page)="cambiarPaginaPaginador($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</section>
<app-info-tramite [tramiteActual]="tramiteSeleccionado" *ngIf="showFormByUser==true"></app-info-tramite>

<div *ngIf="showFormByUser==true">
    <button type="button" class="btn-govco fill-btn-govco" style="margin-right: 10px" (click)="volver()">Volver
    </button>
</div>